import React from "react";
import moment from "moment";
import { numberWithCommas, switchDotsAndCommas } from "../../util/utilFunction";

const formatAngka = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return switchDotsAndCommas(numberWithCommas(value));
};

function getWeekOfMonth(dateStr) {
  const date = moment(dateStr, "YYYY-MM-DD");
  const startOfMonth = date.clone().startOf("month");
  const firstWeekStart = startOfMonth.clone().startOf("isoWeek");

  const diffDays = date.diff(firstWeekStart, "days");
  const weekNumber = Math.floor(diffDays / 7) + 1;

  return weekNumber > 4 ? 4 : weekNumber;
}

function hitungPcsPerWeek(jadwalKirim = []) {
  const totalPerWeek = { 1: 0, 2: 0, 3: 0, 4: 0 };

  jadwalKirim.forEach((jadwal) => {
    if (!jadwal?.date || !jadwal?.jumlah) return;
    const week = getWeekOfMonth(jadwal.date);
    totalPerWeek[week] += jadwal.jumlah;
  });

  return totalPerWeek;
}

function getPemakaianPerWeek(pemakaian) {
  const p = pemakaian || {};
  return {
    week1: p.week1 ?? 0,
    week2: p.week2 ?? 0,
    week3: p.week3 ?? 0,
    week4: p.week4 ?? 0,
  };
}

const thStyle = {
  border: "1px solid #d0d0d0",
  padding: "8px 10px",
  background: "#f2f2f2",
  fontSize: "13px",
  textAlign: "center",
  whiteSpace: "nowrap",
};

const thForecastGroupStyle = {
  ...thStyle,
  background: "#bcdcf7",
  color: "#0b4a80",
  fontWeight: 700,
};

const thForecastStyle = {
  ...thStyle,
  background: "#e3f0fb",
};

const thUsageGroupStyle = {
  ...thStyle,
  background: "#ffd9a8",
  color: "#7a4200",
  fontWeight: 700,
};

const thUsageStyle = {
  ...thStyle,
  background: "#fff1de",
};

const tdStyle = {
  border: "1px solid #e0e0e0",
  padding: "6px 10px",
  fontSize: "13px",
  textAlign: "right",
};

const tdForecastStyle = {
  ...tdStyle,
  background: "#eef6fd",
};

const tdUsageStyle = {
  ...tdStyle,
  background: "#fff6ea",
};

const tdSelisihPositifStyle = {
  ...tdStyle,
  background: "#e6f7ea",
  color: "#0f6b2c",
  fontWeight: 700,
};

const tdSelisihNegatifStyle = {
  ...tdStyle,
  background: "#fde8e8",
  color: "#a3231f",
  fontWeight: 700,
};

const tdLeftStyle = { ...tdStyle, textAlign: "left" };

const MrpPendukungTable = ({ data }) => {
  if (!data || data.length === 0) return null;

  const groupedMap = new Map();

  data.forEach((item) => {
    const jumlah = item.jumlah ?? 0;
    const bj = item.dataBarangJadi;
    if (!bj) return;

    const pendukungList = [
      {
        kode: bj.pendukung1,
        label: bj.labelPendukung1,
        pemakaian: bj.pemakaianPendukung1,
      },
      {
        kode: bj.pendukung2,
        label: bj.labelPendukung2,
        pemakaian: bj.pemakaianPendukung2,
      },
      {
        kode: bj.pendukung3,
        label: bj.labelPendukung3,
        pemakaian: bj.pemakaianPendukung3,
      },
    ].filter((p) => p.kode !== null && p.kode !== undefined && p.kode !== "");

    if (pendukungList.length === 0) return;

    const perWeek = hitungPcsPerWeek(item.jadwalKirim);

    pendukungList.forEach(({ kode, label, pemakaian }) => {
      if (!groupedMap.has(kode)) {
        const actual = getPemakaianPerWeek(pemakaian);

        groupedMap.set(kode, {
          kodePendukung: kode,
          labelPendukung: label ?? "-",
          totalPcs: 0,
          week1: 0,
          week2: 0,
          week3: 0,
          week4: 0,
          actualWeek1: actual.week1,
          actualWeek2: actual.week2,
          actualWeek3: actual.week3,
          actualWeek4: actual.week4,
        });
      }
      const group = groupedMap.get(kode);
      group.totalPcs += jumlah;
      group.week1 += perWeek[1];
      group.week2 += perWeek[2];
      group.week3 += perWeek[3];
      group.week4 += perWeek[4];
    });
  });

  const rows = Array.from(groupedMap.values())
    .map((row) => {
      const actualTotal =
        row.actualWeek1 + row.actualWeek2 + row.actualWeek3 + row.actualWeek4;
      return {
        ...row,
        actualTotal,
        selisih: row.totalPcs - actualTotal,
      };
    })
    .sort((a, b) => b.totalPcs - a.totalPcs);

  if (rows.length === 0) return null;

  return (
    <div style={{ overflowX: "auto", marginTop: "12px" }}>
      <h3 style={{ marginBottom: "8px" }}>Pendukung</h3>
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          minWidth: "1200px",
        }}
      >
        <thead>
          <tr>
            <th style={thStyle} rowSpan={2}>
              Kode
            </th>
            <th style={thStyle} rowSpan={2}>
              Nama
            </th>
            <th style={thStyle} rowSpan={2}>
              Pemakaian <br />
              (Pcs)
            </th>
            <th style={thForecastGroupStyle} colSpan={4}>
              Forecast (Pcs)
            </th>
            <th style={thUsageGroupStyle} colSpan={4}>
              Penggunaan Aktual (Pcs)
            </th>
            <th style={thStyle} rowSpan={2}>
              Selisih
            </th>
          </tr>
          <tr>
            <th style={thForecastStyle}>W 1</th>
            <th style={thForecastStyle}>W 2</th>
            <th style={thForecastStyle}>W 3</th>
            <th style={thForecastStyle}>W 4</th>
            <th style={thUsageStyle}>W 1</th>
            <th style={thUsageStyle}>W 2</th>
            <th style={thUsageStyle}>W 3</th>
            <th style={thUsageStyle}>W 4</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.kodePendukung}>
              <td style={tdLeftStyle}>{row.kodePendukung}</td>
              <td style={tdLeftStyle}>{row.labelPendukung}</td>
              <td style={tdStyle}>{formatAngka(row.totalPcs)}</td>
              <td style={tdForecastStyle}>{formatAngka(row.week1)}</td>
              <td style={tdForecastStyle}>{formatAngka(row.week2)}</td>
              <td style={tdForecastStyle}>{formatAngka(row.week3)}</td>
              <td style={tdForecastStyle}>{formatAngka(row.week4)}</td>
              <td style={tdUsageStyle}>{formatAngka(row.actualWeek1)}</td>
              <td style={tdUsageStyle}>{formatAngka(row.actualWeek2)}</td>
              <td style={tdUsageStyle}>{formatAngka(row.actualWeek3)}</td>
              <td style={tdUsageStyle}>{formatAngka(row.actualWeek4)}</td>
              <td
                style={
                  row.selisih < 0
                    ? tdSelisihNegatifStyle
                    : tdSelisihPositifStyle
                }
              >
                {formatAngka(row.selisih)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MrpPendukungTable;
